import { Component, OnInit } from '@angular/core';
import { customer } from './model/customer';
import { BookServiceService } from './book-service.service';
import { Router } from '@angular/router';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent  {
  

}
